import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, AppConfig } from '../../../../app.config';
import { Observable } from 'rxjs';

import { ProfileApi } from '../api/profile.api';
import { ClubApi } from '../api/club.api';

@Injectable({
  providedIn: 'root'
})
export class ProfileHttpService {

  constructor(private readonly http: HttpClient, @Inject(APP_CONFIG) private readonly config: AppConfig) {}

  fetchProfile(userId: string | undefined): Observable<ProfileApi> {
    const url = `${this.config.profileUrl}/${userId}/profile`;

    return this.http.get<ProfileApi>(url);
  }

  patchProfile(userId: string, data: any): Observable<any> {
    const url = `${this.config.profileUrl}/${userId}/profile`

    return this.http.patch<ProfileApi>(url, data);
  }

  addClubToUser(userId: string, data: any): Observable<any> {
    const url = `${this.config.profileUrl}s/${userId}/clubs`

    return this.http.post<ClubApi>(url, data);
  }
}
